// Event callback to allow only numbers and decimal points to be input
export const isNumber = (event: KeyboardEvent, allowNegative?: boolean): void => {
    const allowedKeys: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ...allowNegative ? '-' : ''];
    const { key } = event;

    if (!allowedKeys.includes(key)) {
        event.preventDefault();
    }
};

export const isInteger = (event: KeyboardEvent, allowNegative?: boolean): void => {
    const allowedKeys: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ...allowNegative ? '-' : ''];
    const { key } = event;

    if (!allowedKeys.includes(key)) {
        event.preventDefault();
    }
};